// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-date-picker-table table {\n    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n    top: 0;\n    table-layout: fixed;\n    width: 83% !important;\n}\n", ""]);
// Exports
module.exports = exports;
